import { render, staticRenderFns } from "./FormationAssetsList.vue?vue&type=template&id=4daa3ba3&"
import script from "./FormationAssetsList.vue?vue&type=script&lang=js&"
export * from "./FormationAssetsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports